<button class="ui-btn borderless-btn back-btn" (click)="onClickBackBtn()">
  <fa-icon [icon]="faChevronLeft"></fa-icon>
  Retour
</button>

<h1>Choisissez votre moyen de paiement</h1>

<div id="page-container">
  <div id="means-container">
    <fs-credit-cards [pageName]="'select-pay'" [supplier]="activeSupplierId" [cardsList]="cardsList"
      [defaultCardId]="defaultCardId" [selectedCardId]="selectedCardId" (clickCard)="onClickCard($event)"
      (clickNewCard)="onClickNewCard()" (clickRemoveCard)="onClickRemoveCard($event)">
    </fs-credit-cards>
  </div>

  <div id="cart-container1" *apply-access-rights="rights.Cart">
    <fs-fast-picker pageName="select-pay" (clickPay)="onClickPay()" [cartContent]="cartContent"
      [cartAmount]="cartAmount" [supplierId]="activeSupplierId" [payDisabled]="payDisabled"></fs-fast-picker>
  </div>
</div>

<ngx-smart-modal #removeCardModal identifier="removeCardModal" customClass="nsm-centered">
  <div class="modal-header">
    <h2>Supprimer cette carte bleue ?</h2>
  </div>
  <div class="modal-content">
    <p>En la supprimant, vous devez ressaisir les données d'une nouvelle carte.</p>
  </div>
  <div class="modal-footer">
    <button class="ui-btn secondary-btn" (click)="removeCardModal.close()">Non, je la garde</button>
    <button class="ui-btn primary-btn" (click)="onRemoveCardConfirmed()">Oui, je la supprime</button>
  </div>
</ngx-smart-modal>

<ngx-smart-modal #selectPayMeanExitModal identifier="selectPayMeanExitModal" customClass="nsm-centered">
  <div class="modal-header">
    <h2>Quitter le paiement ?</h2>
  </div>
  <div class="modal-content">
    <p>En quittant la page, votre sélection de factures/avoirs sera perdue.</p>
  </div>
  <div class="modal-footer">
    <button class="ui-btn secondary-btn" (click)="selectPayMeanExitModal.close()">Non</button>
    <button class="ui-btn primary-btn" (click)="onSelectPayMeanExitConfirmed()">Oui, quitter</button>
  </div>
</ngx-smart-modal>
